import { Button } from "@mindlercare/ui-web";
import { useState } from "react";
import { useAuth, useInternalAuth } from "../AuthenticationProvider";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PKIcon from "../assets/passkey-icon.png"; // Import is working but typescript thinks it's a module...
import { ErrorMessage } from "../components/ErrorMessage";
import { InfoMessage } from "../components/InfoMessage";
import { usePasskeyOptOut } from "../components/PasskeyOptOutToggle";
import { useTranslation } from "../hooks/useTranslation";

export const SignInWithPasskey = () => {
  const { startPasskeyAuthentication, passkeySupported } = useInternalAuth();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { loginState, resetState } = useAuth();
  const [passkeyOptOut] = usePasskeyOptOut();

  const handleAuthentication = async () => {
    try {
      setErrorMessage(null);
      await startPasskeyAuthentication();
    } catch (error) {
      console.error("Failed to authenticate with passkey", error);
      setErrorMessage(t("PASSKEY_LOGIN_FAILED"));
      resetState();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "470px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Button
          disabled={
            !passkeySupported ||
            passkeyOptOut ||
            loginState === "login-in-progress"
          }
          variant="primary"
          onClick={handleAuthentication}
        >
          <img src={PKIcon} width={24} alt="Passkey Icon" />
          {t("PASSKEY_AUTHENTICATE")}
        </Button>
        {errorMessage && (
          <div style={{ marginLeft: "12px" }}>
            <ErrorMessage errorMessage={errorMessage} />
          </div>
        )}
      </div>
      {!passkeySupported && (
        <InfoMessage infoMessage={t("PASSKEY_NOT_SUPPORTED")} />
      )}
    </div>
  );
};
